import React, { useEffect, useState } from "react";
import {
  Box, Typography, Card, Stack, TextField, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Paper, 
  TablePagination, InputAdornment, CircularProgress, Chip
} from "@mui/material";
import { Search, History, CheckCircle } from "@mui/icons-material";
import { 
  collection, query, where, getDocs, doc, getDoc, orderBy 
} from "firebase/firestore";
import { db, auth } from "../../firebase";

function Retursbooks() {
  const [returnList, setReturnList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [schoolId, setSchoolId] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        const userSnap = await getDoc(doc(db, "users", auth.currentUser.uid));
        const sId = userSnap.data()?.schoolId;
        setSchoolId(sId);
        if (sId) {
          fetchReturns(sId);
        }
      } catch (e) { console.error(e); }
    };
    loadData();
  }, []);

  const fetchReturns = async (sId) => {
    setLoading(true);
    try {
      // Query filters only "Returned" status
      const q = query(
        collection(db, "issued_books"), 
        where("schoolId", "==", sId), 
        where("status", "==", "Returned"),
        orderBy("createdAt", "desc")
      );
      const snap = await getDocs(q);
      setReturnList(snap.docs.map(d => ({ id: d.id, ...d.data() })));
    } catch (e) { 
      console.error(e); 
    } finally { 
      setLoading(false); 
    }
  };

  const filteredData = returnList.filter(item => 
    item.studentName.toLowerCase().includes(search.toLowerCase()) || 
    item.bookName.toLowerCase().includes(search.toLowerCase()) ||
    item.barcodeNo.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box p={1}>
      <Stack direction="row" spacing={1} alignItems="center" mb={3}>
        <History color="primary" />
        <Typography variant="h5" fontWeight={700}>Returned Books History</Typography>
      </Stack>

      <Card sx={{ p: 2, mb: 3, borderRadius: 3, boxShadow: "0 4px 12px rgba(0,0,0,0.05)" }}>
        <TextField 
          fullWidth 
          size="small"
          placeholder="Search by student, book name or barcode..." 
          onChange={(e) => setSearch(e.target.value)}
          InputProps={{ 
            startAdornment: <InputAdornment position="start"><Search /></InputAdornment> 
          }}
        />
      </Card>

      <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: "0 4px 20px rgba(0,0,0,0.08)" }}>
        <Table size="small">
          <TableHead sx={{ bgcolor: "#f1f5f9" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: 700 }}>Sr No</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Student Details</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Book Details</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Issue Date</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Return Date</TableCell>
              <TableCell sx={{ fontWeight: 700 }}>Fine Paid</TableCell>
              <TableCell align="center" sx={{ fontWeight: 700 }}>Status</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={7} align="center">
                  <CircularProgress size={30} sx={{ m: 5 }}/>
                </TableCell>
              </TableRow>
            ) : filteredData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ py: 5, color: 'text.secondary' }}>
                  No return records found.
                </TableCell>
              </TableRow>
            ) : filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item, index) => (
              <TableRow key={item.id} hover>
                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>
                  <Typography variant="body2" fontWeight={600}>{item.studentName}</Typography>
                  <Typography variant="caption" color="text.secondary">{item.className}</Typography>
                </TableCell>
                <TableCell>
                  <Typography variant="body2">{item.bookName}</Typography>
                  <Typography variant="caption" sx={{ bgcolor: '#e2e8f0', px: 0.5, borderRadius: 1 }}>
                    SN: {item.barcodeNo}
                  </Typography>
                </TableCell>
                <TableCell>{item.issueDate}</TableCell>
                <TableCell sx={{ color: "success.main", fontWeight: 600 }}>
                  {item.returnDate}
                </TableCell>
                <TableCell>
                  {item.fineAmount > 0 ? (
                    <Typography color="error.main" fontWeight={700}>₹{item.fineAmount}</Typography>
                  ) : (
                    <Typography color="text.disabled">₹0</Typography>
                  )}
                </TableCell>
                <TableCell align="center">
                  <Chip 
                    icon={<CheckCircle style={{ fontSize: 16 }} />} 
                    label="Returned" 
                    size="small" 
                    sx={{ bgcolor: "#dcfce7", color: "#166534", fontWeight: 700 }} 
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
        <TablePagination 
          component="div" 
          count={filteredData.length} 
          rowsPerPage={rowsPerPage} 
          page={page} 
          onPageChange={(e, n) => setPage(n)} 
        />
      </TableContainer>
    </Box>
  );
}

export default Retursbooks;